// extracted by mini-css-extract-plugin
module.exports = {"Media":"Media__3aSDD","Media--vMiddle":"Media--vMiddle__1PoXI","Media__element":"Media__element__3a6xv","Media__body":"Media__body__2vqCB"};